import clsx from "clsx";
import React, { useState } from "react";
// Import Swiper React components
import { FreeMode, Navigation, Pagination, Thumbs } from "swiper";
import { Swiper, SwiperProps, SwiperSlide } from "swiper/react";
import { SwiperModule } from "swiper/types";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Carousel.css";

interface CarouselProps extends SwiperProps {
  items: React.ReactNode[];
  thumbsItems?: React.ReactNode[];
  additionalClassname?: string;
  navigation?: boolean;
  pagination?: boolean;
}

const Carousel: React.FC<CarouselProps> = ({
  items,
  thumbsItems,
  additionalClassname,
  navigation,
  pagination,
  ...props
}) => {
  /* State */
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  const swiperModules: SwiperModule[] = [
    navigation ? Navigation : undefined,
    pagination ? Pagination : undefined,
    thumbsItems ? Thumbs : undefined,
    thumbsItems ? FreeMode : undefined,
  ].filter(Boolean) as SwiperModule[];

  /* Render */
  return (
    <div data-component="Carousel" className="tw-z-0 tw-relative">
      <Swiper
        modules={swiperModules}
        thumbs={thumbsItems ? { swiper: thumbsSwiper } : undefined}
        navigation={navigation}
        pagination={
          pagination
            ? {
                clickable: true,
                renderBullet: function (index, className) {
                  return (
                    '<span class="' + className + ' !tw-bg-white/70"></span>'
                  );
                },
              }
            : undefined
        }
        className={clsx("rsl-swiper", additionalClassname)}
        {...props}
      >
        {items.map((item, itemIndex) => {
          return <SwiperSlide key={itemIndex}>{item}</SwiperSlide>;
        })}
      </Swiper>
      {thumbsItems && thumbsItems.length > 1 && (
        <div className="tw-mt-2">
          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={8}
            slidesPerView={5}
            navigation={true}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[Navigation, Thumbs, FreeMode]}
            className="rsl-swiper-thumb"
          >
            {thumbsItems.map((thumb, thumbIndex) => {
              return <SwiperSlide key={thumbIndex}>{thumb}</SwiperSlide>;
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default Carousel;
